// extracted by mini-css-extract-plugin
module.exports = {"callToAction":"styles_callToAction__vKs91","icon":"styles_icon__i8hbO","label":"styles_label__s9gRs"};